if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.btn = this.querySelector('.sticky-atc__btn');
        this.btnText = this.btn.querySelector('.sticky-atc__btn-text');
        this.btnPriceEl = this.btn.querySelector('.sticky-atc__btn-price');
        this.pickerType = this.dataset.pickerType;

        this.setupVisibility();
        this.setupPicker();
        this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        this.btn.addEventListener('click', this.onButtonClick.bind(this));
      }

      disconnectedCallback() {
        this.unsubVariant?.();
      }

      setupVisibility() {
        if (this.dataset.displayWhen === 'always') {
          this.classList.add('sticky-atc--visible');
          return;
        }
        const mainBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainBtn) return;
        new IntersectionObserver((entries) => {
          const { isIntersecting, boundingClientRect } = entries[0];
          this.classList.toggle('sticky-atc--visible', !isIntersecting && boundingClientRect.top < 0);
        }).observe(mainBtn);
      }

      setupPicker() {
        const selects = this.querySelectorAll('.sticky-atc__select');
        if (!selects.length) return;

        if (this.pickerType === 'combined') {
          selects[0].addEventListener('change', (e) => this.pushVariantId(e.target.value));
        } else {
          // Separate pickers: resolve variant from selected options
          const variants = JSON.parse(this.querySelector('.sticky-atc__variants-json')?.textContent || '[]');
          selects.forEach((select) => {
            select.addEventListener('change', () => {
              const selected = [...selects].map((s) => s.value);
              const match = variants.find((v) =>
                selected.every((val, i) => v[`option${i + 1}`] === val)
              );
              if (match) this.pushVariantId(match.id);
            });
          });
        }
      }

      // Updates the main product form's variant input and triggers Dawn's variant change flow
      pushVariantId(variantId) {
        const input = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);
        if (input && input.value !== String(variantId)) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onVariantChange({ data: { sectionId, html, variant } }) {
        if (sectionId !== this.sectionId) return;

        // Sync price block
        const priceContainer = this.querySelector(`#sticky-atc-price-container-${this.sectionId}`);
        if (priceContainer) {
          const updated = html.querySelector(`#price-${sectionId}`);
          if (updated) priceContainer.innerHTML = updated.innerHTML;
        }

        // Sync price in button
        if (this.btnPriceEl && variant) {
          this.btnPriceEl.textContent = `${Shopify.formatMoney(variant.price, theme.moneyFormat)} •`;
        }

        // Sync product image
        const img = this.querySelector(`#sticky-atc-image-${this.sectionId}`);
        if (img && variant?.featured_image) {
          img.src = variant.featured_image.src;
          img.alt = variant.featured_image.alt || '';
        }

        // Sync pickers to match main variant
        if (variant) {
          const combined = this.querySelector('.sticky-atc__picker--combined select');
          if (combined) combined.value = variant.id;

          this.querySelectorAll('.sticky-atc__picker--separate select').forEach((sel, i) => {
            sel.value = variant[`option${i + 1}`] || '';
          });
        }

        // Sync button state
        if (!variant) {
          this.setButtonState('unavailable');
        } else if (!variant.available) {
          this.setButtonState('soldout');
        } else {
          this.setButtonState('available');
        }
      }

      setButtonState(state) {
        const strings = window.variantStrings || {};
        if (state === 'available') {
          this.btn.disabled = false;
          // Restore original label — keep price span intact if present
          const label = this.dataset.btnLabel;
          if (this.btnPriceEl) {
            this.btnText.lastChild.textContent = ` ${label}`;
          } else {
            this.btnText.textContent = label;
          }
        } else {
          this.btn.disabled = true;
          this.btnText.textContent = state === 'soldout'
            ? (strings.soldOut || 'Sold out')
            : (strings.unavailable || 'Unavailable');
        }
      }

      onButtonClick() {
        const scrollTarget = this.dataset.scrollTarget;
        if (scrollTarget) {
          const el = document.querySelector(scrollTarget);
          el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // Delegate to main buy button — reuses all of Dawn's ProductForm + CartDrawer logic
        document.getElementById(`ProductSubmitButton-${this.sectionId}`)?.click();
      }
    }
  );
}
